import React from 'react';
import {
    Button,
    FormFeedback,
    Form,
    FormGroup,
    Label,
    Input, Navbar, NavbarBrand
} from 'reactstrap';
import mfgFetch from './mfg-fetch';

class AdminLogin extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            usernameValue: '',
            passwordValue: '',
            loginFailed: false,
        }
    }

    componentWillMount() {
    }


    componentDidMount() {
    }

    submitLogin(e) {
        e.preventDefault();

        this.setState({
            loginFailed: false
        });

        mfgFetch('/api/v1/mfg/login', {
            method: 'POST',
            headers: {
                Accept: `application/json`,
                'Content-type': `application/json`
            },
            body: JSON.stringify({
                manufacturer: '1',
                username: this.state.usernameValue,
                password: this.state.passwordValue
            })
        })
            .then(async (resp) => {
                if (!resp || !resp.ok) {
                    throw "invalid response status";
                }
                let body = await resp.json();
                if (body) {
                    window.sessionStorage.setItem('mfg_token', body.token);
                    window.location = `https://${window.location.hostname}/admin/approvals`;
                }
            })
            .catch((err) => {
                console.error('Could not login', err);
                this.setState({
                    loginFailed: true
                });
            });
    }

    updateUsernameValue(e) {
        this.setState({
            usernameValue: e.target.value
        });
    }

    updatePasswordValue(e) {
        this.setState({
            passwordValue: e.target.value
        });
    }

    render() {
        return (
            <div className="mx-auto">

                <div>
                    <Navbar color="light" light expand>
                        <NavbarBrand className="mfg-title">
                            DDX SmartBrush - Admin Login
                        </NavbarBrand>
                        <span className="ml-auto">
                            <img alt="DDX logo" src="/ddx.png" width={96} height={37} />
                        </span>
                    </Navbar>
                </div>

                <h1 className="mfg-login-title">Smartbrush Admin Login</h1>
                <Form className="mfg-login d-flex flex-column mx-auto" onSubmit={(e) => this.submitLogin(e) }>
                    <FormGroup>
                        <Label>Username</Label>
                        <Input
                            type="text"
                            name="username"
                            id="username"
                            placeholder="your login"
                            value={this.state.usernameValue}
                            onChange={e => this.updateUsernameValue(e)}
                            invalid={this.state.loginFailed}
                        />
                        <Label>Password</Label>
                        <Input
                            type="password"
                            name="password"
                            id="password"
                            placeholder="********"
                            value={this.state.passwordValue}
                            onChange={e => this.updatePasswordValue(e)}
                            invalid={this.state.loginFailed}
                        />
                        <FormFeedback>
                            Looks like there is an issue with either your username or your password. Verify them and try again.
                        </FormFeedback>
                    </FormGroup>
                    <Button className="ml-auto">Submit</Button>
                </Form>

            </div>
        );
    }
}

export default AdminLogin;